import React, { Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import AccessibilityToolbar from "@/components/AccessibilityToolbar";
import AuthGuard from "@/components/AuthGuard";

// Lazy load pages for code splitting
const Index = React.lazy(() => import("./pages/Index"));
const NotFound = React.lazy(() => import("./pages/NotFound"));
const TherapistChatRegistration = React.lazy(() => import("./pages/TherapistChatRegistration"));
const Pricing = React.lazy(() => import("./pages/Pricing"));
const AboutPaca = React.lazy(() => import("./pages/AboutPaca"));
const SharePaca = React.lazy(() => import("./pages/SharePaca"));
const TherapistArea = React.lazy(() => import("./pages/TherapistArea"));
const Auth = React.lazy(() => import("./pages/Auth"));
const ResetPassword = React.lazy(() => import("./pages/ResetPassword"));
const WhatsAppFlowChart = React.lazy(() => import("./pages/WhatsAppFlowChart"));
const MainRouterFlowChart = React.lazy(() => import("./pages/MainRouterFlowChart"));
const DrawIOMainRouter = React.lazy(() => import("./pages/DrawIOMainRouter"));
const PACAPrivateWebBot = React.lazy(() => import("./pages/PACAPrivateWebBot"));
const SystemArchitecture = React.lazy(() => import("./pages/SystemArchitecture"));
const DocumentationDownload = React.lazy(() => import("./pages/DocumentationDownload"));


const queryClient = new QueryClient();

const App = () => (
  <LanguageProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div></div>}>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/auth" element={
                <AuthGuard requireAuth={false}>
                  <Auth />
                </AuthGuard>
              } />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/changepassword" element={<ResetPassword />} />
              <Route path="/therapist-registration" element={<TherapistChatRegistration />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/about-paca" element={<AboutPaca />} />
              <Route path="/share-paca" element={<SharePaca />} />
            <Route path="/whatsapp-flow-chart" element={<WhatsAppFlowChart />} />
            <Route path="/main-router-flow-chart" element={<MainRouterFlowChart />} />
            <Route path="/drawio-main-router" element={<DrawIOMainRouter />} />
            <Route path="/bot" element={<PACAPrivateWebBot />} />
            <Route path="/private-web-bot" element={<PACAPrivateWebBot />} />
            <Route path="/system-architecture" element={<SystemArchitecture />} />
            <Route path="/documentation" element={<DocumentationDownload />} />
              
              <Route path="/therapist-area" element={
                <AuthGuard requireAuth={true}>
                  <TherapistArea />
                </AuthGuard>
              } />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
          <AccessibilityToolbar />
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </LanguageProvider>
);

export default App;
